import { Component, OnInit, OnDestroy } from '@angular/core';
import { ForumService } from 'src/app/services/forum.service';
import Discussion from 'src/app/interfaces/Discussion';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadService } from 'src/app/services/upload.service';
import { ResourceService } from 'src/app/services/resource.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-edit-discussion',
  templateUrl: './edit-discussion.component.html',
  styleUrls: ['./edit-discussion.component.scss'],
})
export class EditDiscussionComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  discussion;
  attachmentFile: File = null;
  attachmentPreviewURL;
  quillModules = {
    toolbar: [['link', 'bold', 'italic', 'underline', 'strike', 'blockquote', { list: 'ordered' }, { list: 'bullet' }]],
  };
  enterBindings = [];
  tags = {
    standard: [
      'technology',
      'environmental-impacts',
      'governance',
      'markets-finance',
      'funding',
      'cdr-community',
      'social-licensing',
    ],
    approaches: ['microalgae', 'blue-carbon', 'macroalgal','alkalinity', 'co2-removal', 'storage', 'other'],
  };
  openAccessCheckbox = false;
  members = [];
  taggedMembers = [];

  constructor(
    private forumService: ForumService,
    private userService: UserService,
    private router: Router,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private resourceService: ResourceService,
    private loadingService: LoadingService,
    private notificationService: NotificationsService,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );

    this.route.queryParams.subscribe((params) => {
      if (params['id']) {
        this.forumService.getDiscussion(params['id']).then((d) => {
          this.discussion = d;
          if (this.discussion.attachment) {
            this.openAccessCheckbox = true;
          }
        });
      }
    });

    this.subscriptions.add(this.userService.getMembers().subscribe((m) => (this.members = m)));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  removeFile() {
    if (this.attachmentFile) {
      this.attachmentFile = null;
    }
    if (this.discussion.attachment) {
      this.discussion.attachment = null;
    }
  }

  save(): void {
    this.discussion.content = this.urlService.processContent(this.discussion.content, this.taggedMembers);
    this.loadingService.startLoading();
    if (this.attachmentFile) {
      this.uploadService.uploadFile(this.attachmentFile).then((downloadUrl) => {
        this.discussion.attachment = {
          name: this.attachmentFile.name,
          url: downloadUrl,
          size: this.attachmentFile.size,
        };
        this.updateDiscussion();
      });
    } else {
      this.updateDiscussion();
    }
  }

  updateDiscussion() {
    this.forumService.updateDiscussion(this.discussion.id, this.discussion).then(
      () => {
        if (this.taggedMembers.length > 0) {
          this.taggedMembers.forEach((tm) => {
            if (this.discussion.content.indexOf('@' + tm.displayName) > -1) {
              this.notificationService.saveNotification(
                tm.uid,
                this.currentUser.uid,
                `mentioned you in a <a href="forum/${this.discussion.id}">discussion</a>`,
                this.currentUser.displayName,
                this.currentUser.profilePicture
              );
              this.notificationService.sendNotifications({
                type: 'directMentions',
                mention: tm.uid,
                comment: this.currentUser.displayName,
                url: `/forum/${this.discussion.id}`,
              });
            }
          });
        }
        this.taggedMembers = [];
        this.loadingService.stopLoading();
        this.router.navigate(['/forum/' + this.discussion.id]);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  upload(event): void {
    if (event.target && event.target.files.length > 0) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        t.attachmentPreviewURL = reader.result;
      };
      if (event.target.files[0].name.endsWith('.pdf')) {
        let $img: any = document.querySelector('input[type="file"]');
        reader.readAsArrayBuffer($img.files[0]);
      }
      if (!event.target.files[0].name.endsWith('.pdf')) reader.readAsDataURL(event.target.files[0]); // convert to base64 string

      this.attachmentFile = event.target.files[0];
      this.openAccessCheckbox = false;
    }
  }

  toggleApproach(a): void {
    if (this.discussion.approaches.indexOf(a) === -1) {
      this.discussion.approaches.push(a);
    } else {
      this.discussion.approaches.splice(this.discussion.approaches.indexOf(a), 1);
    }
  }
  toggleTag(t): void {
    if (this.discussion.tags.indexOf(t) === -1) {
      this.discussion.tags.push(t);
    } else {
      this.discussion.tags.splice(this.discussion.approaches.indexOf(t), 1);
    }
  }

  tagMember(m) {
    this.taggedMembers.push({ email: m.email, displayName: m.displayName, uid: m.uid });
  }

  editorOpened(editor) {
    this.enterBindings = editor.quillEditor.keyboard.bindings[13].map((b) => Object.assign({}, b))
    delete editor.quillEditor.keyboard.bindings[13]
  }
  editorClosed(editor) {
    if (!editor.quillEditor.keyboard.bindings[13]) {
      editor.quillEditor.keyboard.bindings[13] = this.enterBindings.map((b) => Object.assign({}, b))
    }
  }

}
